import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BulkOtAgentsScheduleEditMutationVariables } from '@uigy/generated/graphql';
import { FrequencyEditorInputs } from '@uigy/shared/components/frequency-editor/interface';
import { NotificationComponent } from '@uigy/shared/components/info/notification.component';
import { GenericSliderPage } from '@uigy/shared/components/slider-v2/models/generic-slider-page';
import { ToasterType } from '@uigy/shared/components/toaster/enums/toaster-type.enum';
import { ILabel } from '@uigy/shared/interfaces/label-interface';
import { MaterialModule } from '@uigy/shared/material-module/material.module';
import { LanguageService } from '@uigy/shared/services/language.service';
import {
  FormFrequencyEditorComponent,
} from '@uigy/shared/components/dynamic-form/form-components/form-frequency-editor/form-frequency-editor.component';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  imports: [
    MaterialModule,
    I18NextModule,
    FormFrequencyEditorComponent,
    NotificationComponent,
    ReactiveFormsModule,
  ],
  selector: 'app-ot-agent-set-schedule-slider',
  templateUrl: './ot-agent-set-schedule-slider.component.html',
  styleUrl: './ot-agent-set-schedule-slider.component.scss'
})
export class OtAgentSetScheduleSliderComponent implements GenericSliderPage<BulkOtAgentsScheduleEditMutationVariables, BulkOtAgentsScheduleEditMutationVariables> {
  private languageService = inject(LanguageService);
  protected readonly otAgentsTexts = this.languageService.texts.ot_agents;
  protected readonly toasterType = ToasterType;

  public frequencyControl = new UntypedFormControl();
  public form: UntypedFormGroup = new UntypedFormGroup({
    schedule: this.frequencyControl
  });

  public frequencyEditorConfig: FrequencyEditorInputs & ILabel = {
    durations: 'mhdw',
    label: this.otAgentsTexts.edit_agent.repeats_every
  };

  private data?: BulkOtAgentsScheduleEditMutationVariables;

  constructor() {}


  public getData(): BulkOtAgentsScheduleEditMutationVariables {
    return {
      schedule: this.frequencyControl.value,
      filter: this.data?.filter,
      search: this.data?.search,
      enable: true
    };
  }

  public initData(data: BulkOtAgentsScheduleEditMutationVariables): void {
    this.data = data;
  }

  public isValid(): boolean {
    return true;
  }
}
